import React from "react";


const Image = ({ image }) => {
    const srcFake = "https://fakeimg.pl/350x200/?text=...&font=lobster"
    return (
        <img className="card-img-top example-image"
            src={srcFake}
            data-src={image}
        />
    )
}



export default function Project({ project }) {
    return (

        <div className="col-md-4 text-center">
            <div className="card mb-4 box-shadow">

                {
                    project.type ? <video src={project.image} autoPlay muted loop ></video> :
                        /*<a className="example-image-link" href={project.image} data-lightbox="example-1">*/
                            <Image image={project.image} />
                        /*</a>*/
                }

                <div className="card-body cd-body">
                    <h5 className="card-title">{project.name}</h5>
                    <h6 className="card-subtitle mb-2 text-muted">{project.description}</h6>
                    <h6 className="card-subtitle mb-2 text-muted">
                        {
                            project.technologies.map((tec, index) => (<span key={index} className="badge rounded-pill bg-dark text-white m-1">{tec}</span>))
                        }

                    </h6>
                </div>
            </div>
        </div>

    )
}
